// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAdBsU2oEoMKrDhNzpJb379VKpGfN3PqHQ",
  authDomain: "coderpixelinnovations.firebaseapp.com",
  databaseURL: "https://coderpixelinnovations-default-rtdb.firebaseio.com",
  projectId: "coderpixelinnovations",
  storageBucket: "coderpixelinnovations.firebasestorage.app",
  messagingSenderId: "1093908585788",
  appId: "1:1093908585788:web:b0a5b3860b9e50c4e75239",
  measurementId: "G-GQ1C9V537K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth };